export default __webpack_public_path__ + "src/dataset/galleries-83f7-6a51e9.txt";